import { render } from "./Code.vue?vue&type=template&id=5cd0f70f"
import script from "./Code.vue?vue&type=script&lang=js"
export * from "./Code.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "5cd0f70f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5cd0f70f', script)) {
    api.reload('5cd0f70f', script)
  }
  
  module.hot.accept("./Code.vue?vue&type=template&id=5cd0f70f", () => {
    api.rerender('5cd0f70f', render)
  })

}

script.__file = "src/icons/components/filled/Code.vue"

export default script